"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyByProp = exports.keyBy = exports.keyWith = exports.compileChecks = exports.makeEnsureUnionFromRecord = exports.makeAllUnionTuple = exports.safeDefinition = exports.safeIndex = exports.setFromKey = exports.makeWritable = exports.makeConstFromInterface = exports.tuple = exports.doesObjectHaveKey = exports.groupIdFieldByField = exports.groupBy = exports.keys = exports.assert = exports.assertEnum = exports.ensureEnumOrNull = exports.isEnum = exports.isNumberArray = exports.filterAreFieldsTruthy = exports.areFieldsTruthy = exports.isTruthy = void 0;
// Use isTruthy in .filter to get the right type at the exit of the function e.g.:
// [1,2,3,null].filter(v => !!v) <== has type Array<number | null>
// [1,2,3,null].filter(isTruthy) <== has type Array<number>
function isTruthy(value) {
    return !!value;
}
exports.isTruthy = isTruthy;
function areFieldsTruthy(value, ..._keys) {
    if (!isTruthy(value)) {
        return false;
    }
    for (const key of _keys) {
        if (!value[key]) {
            return false;
        }
    }
    return true;
}
exports.areFieldsTruthy = areFieldsTruthy;
function filterAreFieldsTruthy(..._keys) {
    return (value) => {
        if (!isTruthy(value)) {
            return false;
        }
        for (const key of _keys) {
            if (!value[key]) {
                return false;
            }
        }
        return true;
    };
}
exports.filterAreFieldsTruthy = filterAreFieldsTruthy;
function isNumberArray(array) {
    return array.every((item) => typeof item === "number");
}
exports.isNumberArray = isNumberArray;
function isEnum(Enum, value) {
    return Object.values(Enum).some((v) => v === value);
}
exports.isEnum = isEnum;
function ensureEnumOrNull(Enum, value) {
    return isEnum(Enum, value) ? value : null;
}
exports.ensureEnumOrNull = ensureEnumOrNull;
function assertEnum(Enum, value) {
    return value;
}
exports.assertEnum = assertEnum;
function assert(condition, msg) {
    if (!condition) {
        throw new Error(`Assertion Failed${msg ? `: ${msg}` : ""}`);
    }
}
exports.assert = assert;
function keys(object) {
    return Object.keys(object);
}
exports.keys = keys;
// Same functionality as lodash groupBy, but with ability to properly infer keys
function groupBy(arr, key) {
    return arr.reduce((acc, obj) => {
        var _a;
        const value = obj[key];
        if (acc[value]) {
            (_a = acc[value]) === null || _a === void 0 ? void 0 : _a.push(obj);
        }
        else {
            acc[value] = [obj];
        }
        return acc;
    }, {});
}
exports.groupBy = groupBy;
function groupIdFieldByField(arr, key, field) {
    return arr.reduce((acc, obj) => {
        var _a;
        const value = obj[key];
        if (acc[value]) {
            (_a = acc[value]) === null || _a === void 0 ? void 0 : _a.push(obj[field]);
        }
        else {
            acc[value] = [obj[field]];
        }
        return acc;
    }, {});
}
exports.groupIdFieldByField = groupIdFieldByField;
function doesObjectHaveKey(obj, key) {
    return key in obj;
}
exports.doesObjectHaveKey = doesObjectHaveKey;
// Allows to do make mutable tuple (where readonly tuple don't work)
// mutableTupleExample is type: [string, number, { b: number; }]
// vs
// const readonlyTupleExample = ["a", 1, {b: 1}] as const;
// readonlyTupleExample is type: readonly ["a", 1, { readonly b: 1; }]
function tuple(...args) {
    return args;
}
exports.tuple = tuple;
function makeConstFromInterface() {
    return (o) => o;
}
exports.makeConstFromInterface = makeConstFromInterface;
function makeWritable(value) {
    return value;
}
exports.makeWritable = makeWritable;
function setFromKey(to, from, k) {
    to[k] = from[k];
}
exports.setFromKey = setFromKey;
function safeIndex(object, key) {
    if (typeof key === "string" && object.hasOwnProperty(key)) {
        return object[key];
    }
    return undefined;
}
exports.safeIndex = safeIndex;
function safeDefinition() {
    return function (i) {
        return i;
    };
}
exports.safeDefinition = safeDefinition;
// https://github.com/microsoft/TypeScript/issues/13298#issuecomment-596068031
const makeAllUnionTuple = () => (cc) => cc;
exports.makeAllUnionTuple = makeAllUnionTuple;
function makeEnsureUnionFromRecord() {
    return (0, exports.makeAllUnionTuple)();
}
exports.makeEnsureUnionFromRecord = makeEnsureUnionFromRecord;
exports.compileChecks = {
    obj(obj) {
        return {
            isInterfaceTo(i) {
                /* noop */
            },
        };
    },
    keysInRecord(cc) {
        return cc;
    },
    // compileChecks.switchDefault(type).exhaustive() allows us to make sure that before reaching default,
    // all possible cases have been checked!
    switchDefault(switchTarget) {
        return {
            exhaustive(...args) {
                /* noop */
            },
        };
    },
    isNever(...obj) {
        /* noop */
    },
    tests() {
        const target = null;
        switch (target) {
            default:
                // @ts-expect-error
                exports.compileChecks.switchDefault(target).exhaustive();
                // This should error because the return is not used (aka .exhaustive() is not called)
                // But I don't know how to achieve this with today's options
                exports.compileChecks.switchDefault(target);
                // @ts-expect-error
                exports.compileChecks.switchDefault(target).exhaustive();
                exports.compileChecks.switchDefault(target).exhaustive();
        }
        switch (target) {
            case "T1":
                break;
            default:
                // @ts-expect-error
                exports.compileChecks.switchDefault(target).exhaustive();
                // @ts-expect-error
                exports.compileChecks.switchDefault(target).exhaustive();
                // @ts-expect-error
                exports.compileChecks.switchDefault(target).exhaustive("T1");
                exports.compileChecks.switchDefault(target).exhaustive();
        }
        switch (target) {
            case "T1":
            case "T2":
                break;
            default:
                exports.compileChecks.switchDefault(target).exhaustive();
                exports.compileChecks.isNever();
        }
        // @ts-expect-error
        exports.compileChecks.isNever();
        exports.compileChecks.isNever();
    },
};
``;
function keyWith(arr, getKey, mapValue) {
    return arr.reduce((m, v) => {
        m[getKey(v)] = (mapValue ? mapValue(v) : v);
        return m;
    }, {});
}
exports.keyWith = keyWith;
function keyBy(arr, key, mapValue) {
    return keyWith(arr, (v) => v[key], mapValue);
}
exports.keyBy = keyBy;
function keyByProp(arr, key, prop) {
    return keyWith(arr, (v) => v[key], (v) => v[prop]);
}
exports.keyByProp = keyByProp;
//# sourceMappingURL=typingHelpers.js.map